export interface NewKitPickupClinicAccount {
  lims_id: string;
  sfname: string;
  sfid: string;
  phone: string;
  office_fax: string;
  billingstreet: string;
  billingcity: string;
  billingstatecode: string;
  billingpostalcode: string;
  billingcountrycode: string;
  is_standard_account: boolean;
}

export interface NewKitPickupDetails {
  ready_date: string;
  ready_time: string;
  customer_close_time: string;
  person_name: string;
}

export interface NewKitPickupOrder {
  ready_timestamp: string;
  customer_close_time: string;
  person_name: string;
  account_lims_id: string;
  is_future_day: boolean;
}

export interface KitPickupErrorDetails {
  isInternationalAccountError: boolean;
  isEmptyFieldsError: boolean;
  isCustomerCloseTimeError: boolean;
  isReadyDateError: boolean;
  isReadyDateDayOfWeekError: boolean;
  isEarlyReadyTimeError: boolean;
  isSameDayPickupError: boolean;
  isAPIError: boolean;
  apiErrorMessage?: string;
}

export interface KitPickupSubmissionSuccess {
  true: {
    "Pickup 8-Digit Confirmation Code": string;
  };
}

export interface KitPickupSubmissionError {
  false: Record<string, unknown>;
}

export interface KitPickupSubmissionResponse {
  success: string;
  confirmation_code: string;
  error_message?: string;
}

export enum KitStepper {
  Order = 0,
  Confirmation = 1,
  Complete = 2,
}
